import {
  LayoutDashboard,
  UserCog,
  Users,
  UserCheck,
  ClipboardList,
  FileBarChart,
  ShieldCheck,
  Headphones,
  Coins,
  ArrowLeftRight,
  Users2,
  ScanFace,
  CandlestickChart,
  Wallet,
  Building2,
  Gift,
  LayoutGrid,
  Megaphone,
  Share2,
  Mail,
  MessagesSquare,
  Settings,
  Trophy,
  ShieldAlert,
  Bot,
  Brain,
  Sparkles,
  TrendingUp,
  Globe2,
  PhoneCall,
  ServerCog,
  Gem,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  label: string;
  to?: string;
  icon?: LucideIcon;
  badge?: string;
  children?: NavItem[];
}

/**
 * Full admin sidebar tree. Mirrors every section in the standard broker
 * reference (User-Manual sections 1–32). Routes that aren't wired yet
 * fall through to ModuleStub via the App.tsx catch-all.
 */
export const adminNav: NavItem[] = [
  { label: "Dashboard", to: "/admin/dashboard", icon: LayoutDashboard },
  {
    label: "Admin Profile",
    icon: UserCog,
    children: [
      { label: "Change Profile", to: "/admin/profile" },
      { label: "Notifications", to: "/admin/notifications" },
    ],
  },
  {
    label: "Manage Client",
    icon: Users,
    children: [
      { label: "Client Admin", to: "/admin/manage-client/trader-admin" },
      { label: "Client Analysis", to: "/admin/manage-client/trader-analysis" },
    ],
  },
  {
    label: "Partner Management",
    icon: UserCheck,
    children: [
      { label: "Partner Registration", to: "/admin/ib/registration" },
      { label: "Partner Setup", to: "/admin/ib/setup" },
      { label: "Multi-level Commission", to: "/admin/ib/multilevel-commission" },
      { label: "Custom Multi-level", to: "/admin/ib/multilevel-custom" },
      { label: "Custom Partner Commission", to: "/admin/ib/custom-rates" },
      { label: "Partner Tree", to: "/admin/ib/tree" },
      { label: "Partner Chain", to: "/admin/ib/chain" },
      { label: "Pending Commission", to: "/admin/ib/pending-commission" },
      { label: "Partner Admin", to: "/admin/ib/admin-report" },
      { label: "Partner Analysis", to: "/admin/ib/analysis" },
    ],
  },
  {
    label: "Manage Request",
    icon: ClipboardList,
    children: [
      { label: "Bank Request", to: "/admin/requests/bank" },
      { label: "Deposit Request", to: "/admin/requests/deposit" },
      { label: "Withdraw Request", to: "/admin/requests/withdraw" },
      { label: "Balance Transfer", to: "/admin/requests/balance-transfer" },
      { label: "Partner Transfer", to: "/admin/requests/ib-transfer" },
      { label: "Partner Withdraw", to: "/admin/requests/ib-withdraw" },
    ],
  },
  {
    label: "Reports",
    icon: FileBarChart,
    children: [
      { label: "Online Users", to: "/admin/reports/online-users" },
      { label: "Partner Withdraw", to: "/admin/reports/ib-withdraw" },
      { label: "Partner Commission", to: "/admin/reports/ib-commission" },
      { label: "Partner Commission Summary", to: "/admin/reports/ib-commission-report" },
      { label: "Client Withdraw", to: "/admin/reports/trader-withdraw" },
      { label: "Client Deposit", to: "/admin/reports/trader-deposit" },
      { label: "Blocked Users", to: "/admin/reports/blocked-users" },
      { label: "Activity Log", to: "/admin/reports/activity-log" },
      { label: "Bonus Report", to: "/admin/reports/bonus" },
      { label: "Credit Report", to: "/admin/reports/credit" },
      { label: "Partner Fund Transfer", to: "/admin/reports/ib-fund-transfer" },
      { label: "External Fund Transfer", to: "/admin/reports/external-fund-transfer" },
      { label: "Partner Balance Add", to: "/admin/reports/ib-balance-add" },
      { label: "Ledger Report", to: "/admin/reports/ledger" },
      { label: "Individual Ledger", to: "/admin/reports/individual-ledger" },
      { label: "Call Logs", to: "/admin/reports/call-logs" },
      { label: "Impersonation Log", to: "/admin/reports/impersonation" },
    ],
  },
  {
    label: "Manage Admin",
    icon: ShieldCheck,
    children: [
      { label: "Role Management", to: "/admin/admins/groups" },
      { label: "Admin List", to: "/admin/admins/list" },
      { label: "Module Control", to: "/admin/modules" },
      { label: "Demo Data", to: "/admin/demo-data" },
    ],
  },
  {
    label: "Manager Settings",
    icon: Headphones,
    children: [
      { label: "Add Manager", to: "/admin/managers/add" },
      { label: "Manager List", to: "/admin/managers/list" },
    ],
  },
  {
    label: "Finance",
    icon: Coins,
    children: [
      { label: "Balance Management", to: "/admin/finance/balance" },
      { label: "Credit Management", to: "/admin/finance/credit" },
      { label: "Wallet Credit", to: "/admin/finance/wallet-credit" },
      { label: "Fund Management", to: "/admin/finance/fund" },
      { label: "Admin Deposit", to: "/admin/finance/admin-deposit" },
      { label: "Admin Withdraw", to: "/admin/finance/admin-withdraw" },
    ],
  },
  {
    label: "Fund Transfer",
    icon: ArrowLeftRight,
    children: [
      { label: "Internal", to: "/admin/fund-transfer/internal" },
      { label: "External", to: "/admin/fund-transfer/external" },
    ],
  },
  {
    label: "Group Settings",
    icon: Users2,
    children: [
      { label: "Group Manager", to: "/admin/groups/create" },
      { label: "Group List", to: "/admin/groups/list" },
      { label: "Manage Partner Group", to: "/admin/groups/ib" },
      { label: "Manage CPA Partner Group", to: "/admin/groups/cpa-ib" },
    ],
  },
  {
    label: "KYC Management",
    icon: ScanFace,
    children: [
      { label: "KYC Settings", to: "/admin/kyc/settings" },
      { label: "KYC Request", to: "/admin/kyc/request" },
    ],
  },
  {
    label: "Manage Trade",
    icon: CandlestickChart,
    children: [
      { label: "Trading Report", to: "/admin/trade/report" },
      { label: "Trade Commission", to: "/admin/trade/commission" },
      { label: "Copy Trading", to: "/admin/copy-trading" },
      { label: "PAMM / MAM Funds", to: "/admin/funds" },
    ],
  },
  {
    label: "Manage Accounts",
    icon: Wallet,
    children: [
      { label: "Live Accounts", to: "/admin/accounts/live" },
      { label: "Demo Accounts", to: "/admin/accounts/demo" },
      { label: "MT5 Connection", to: "/admin/mt5/connection" },
    ],
  },
  {
    label: "Manage Banks",
    icon: Building2,
    children: [{ label: "Company Bank List", to: "/admin/banks/company" }],
  },
  {
    label: "Offers",
    icon: Gift,
    children: [
      { label: "Create Bonus", to: "/admin/offers/create" },
      { label: "Bonus Packages", to: "/admin/offers/packages" },
      { label: "Bonus Report", to: "/admin/offers/report" },
      { label: "Bonus Request", to: "/admin/offers/request" },
      { label: "Bonus Log", to: "/admin/offers/log" },
      { label: "Loyalty Settings", to: "/admin/offers/loyalty" },
      { label: "Loyalty Ledger", to: "/admin/offers/loyalty-ledger" },
      { label: "Trade & Win Rewards", to: "/admin/offers/rewards" },
      { label: "Reward Dashboard", to: "/admin/offers/reward-dashboard" },
      { label: "Reward Claims", to: "/admin/offers/reward-claims" },
      { label: "Ranks & Coins", to: "/admin/offers/coins" },
    ],
  },
  {
    label: "Wealth & MLM",
    icon: Gem,
    children: [
      { label: "Profit Sharing", to: "/admin/wealth/profit-sharing" },
      { label: "Profit Share Levels", to: "/admin/wealth/profit-share-levels" },
      { label: "Network Rewards", to: "/admin/wealth/network-rewards" },
      { label: "Funded Challenges", to: "/admin/wealth/funded-challenges" },
      { label: "Investment Products", to: "/admin/wealth/investment-products" },
      { label: "Master Fee", to: "/admin/wealth/master-fee" },
    ],
  },
  {
    label: "Contest",
    icon: Trophy,
    children: [
      { label: "Contest Dashboard", to: "/admin/contest/dashboard" },
      { label: "Create Contest", to: "/admin/contest/create" },
    ],
  },
  { label: "EA Catalogue", to: "/admin/ea/catalogue", icon: Bot },
  { label: "Support Tickets", to: "/admin/support", icon: MessagesSquare },
  {
    label: "Settings",
    icon: Settings,
    children: [
      { label: "Company Setup", to: "/admin/settings?tab=company" },
      { label: "Branding & Logo", to: "/admin/settings?tab=branding" },
      { label: "Dashboard Theme", to: "/admin/settings?tab=dashboard" },
      { label: "Social Links", to: "/admin/settings?tab=social" },
      { label: "Footer Links", to: "/admin/settings?tab=footer" },
      { label: "SMTP Setup", to: "/admin/settings?tab=smtp" },
      { label: "Finance Setup", to: "/admin/settings/finance" },
      { label: "Payment Gateway", to: "/admin/settings/payment-gateway" },
      { label: "Partner Settings", to: "/admin/settings/ib" },
      { label: "Security Settings", to: "/admin/settings/security" },
      { label: "Client Settings", to: "/admin/settings/trader" },
      { label: "Client Sidebar", to: "/admin/settings/trader-sidebar" },
      { label: "Trading Platforms", to: "/admin/settings/platforms" },
      { label: "Mobile App", to: "/admin/settings/mobile" },
      { label: "Email Templates", to: "/admin/email" },
    ],
  },
];
